import CloseIcon from '@mui/icons-material/Close';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { Box, Button, IconButton, Tooltip } from '@mui/material';
import React from 'react';

interface IProps {
  onReset?: () => void;
  onChangeTemplate: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  onRemove?: () => void;
  disabled?: boolean;
}

const iconButtonStyles = {
  backgroundColor: 'transparent',
  '&:hover': {
    backgroundColor: 'action.hover',
  },
};

export const ClaimLinkTemplateSelectorActions: React.FC<IProps> = ({
  onReset,
  onChangeTemplate,
  onRemove,
  disabled,
}) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
      <Button
        variant="outlined"
        color="primary"
        onClick={onChangeTemplate}
        disabled={disabled}
        sx={{ whiteSpace: 'nowrap', flex: 1 }}
        data-action="change_template"
      >
        Change template
      </Button>
      {onReset && (
        <Tooltip title="Reset to org default" placement="top" arrow>
          <span>
            <IconButton
              onClick={onReset}
              disabled={disabled}
              aria-label="Reset to org default"
              sx={iconButtonStyles}
              data-action="reset_to_org_default"
            >
              <RestartAltIcon />
            </IconButton>
          </span>
        </Tooltip>
      )}
      {onRemove && (
        <Tooltip title="Remove template" placement="top" arrow>
          <span>
            <IconButton
              onClick={onRemove}
              disabled={disabled}
              aria-label="Remove template"
              sx={iconButtonStyles}
              data-action="remove_template"
            >
              <CloseIcon />
            </IconButton>
          </span>
        </Tooltip>
      )}
    </Box>
  );
};
